import moment from 'moment';
import {
    eventEmitter,
    homeService,
} from '../services';
import configDev from '../config.dev.json';
import configProd from '../config.prod.json';

const REGEX_VALIDAR_EMAIL = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
const REGEX_VALIDAR_SENHA = /^(?=.*[A-Z].*)(?=.*[a-z].*)(?=.*[\d@.;:/<>=$#!*&%[\]{}].*).{8,}.+$/;
let MENUS = null;
let USUARIO_LOGADO = false;

class Utils {
    static getConfig() {
        if (process.env.NODE_ENV === 'production') {
            return configProd;
        }
        return configDev;
    }

    static getUsuarioEstaLogado() {
        return USUARIO_LOGADO;
    }

    static setUsuarioEstaLogado(usuarioLogado) {
        USUARIO_LOGADO = usuarioLogado;
    }

    static getFormatDate(data) {
        if (!data) {
            return '-';
        }
        return moment(data).format('DD/MM/YYYY');
    }


    static setFormatDate(data) {
        return `${data.substr(3, 2)}/${data.substr(0, 2)}/${data.substr(6, 4)}`;
    }

    static getFormatDateTime(data) {
        return moment(data).format('DD/MM/YYYY HH:mm:ss');
    }

    static getFormatHora(data) {
        if (!data) {
            return '-';
        }
        return moment(data).format('HH:mm:ss');
    }

    static async getMenus() {
        if (!MENUS) {
            try {
                MENUS = (await this.getInformacoesPessoaLogada()).menus;
                this.setUsuarioEstaLogado(true);
            } catch (error) {
                MENUS = (await homeService.getMenusPublicos()).menus;
                this.setUsuarioEstaLogado(false);
            }
        }
        return MENUS;
    }

    static getInformacoesPessoaLogada() {
        return homeService.getInformacoesPessoaLogada();
    }

    static showToast(message) {
        eventEmitter.emmit('toast', { message });
    }

    static showLoading(show, text) {
        eventEmitter.emmit('loading', { show, text });
    }

    static isSenhaValida(senha) {
        return REGEX_VALIDAR_SENHA.test(senha);
    }

    static isDataValida(date) {
        return moment(date, 'DD/MM/YYYY').isValid();
    }

    static isEmailValido(email) {
        return REGEX_VALIDAR_EMAIL.test(email.toLowerCase());
    }

    static formatCPF(cpf) {
        return `${cpf.substr(0, 3)}.${cpf.substr(3, 3)}.${cpf.substr(6, 3)}-${cpf.substr(9, 2)}`;
    }

    static isCPFValido(cpf) {
        const cpfSemCaracteresEspeciais = cpf.replace(/\D/g, '');
        let soma = 0;
        let resto = 0;
        if (cpfSemCaracteresEspeciais === '00000000000') {
            return false;
        }
        for (let i = 1; i <= 9; i += 1) {
            soma += parseInt(cpfSemCaracteresEspeciais.substring(i - 1, i), 10) * (11 - i);
        }
        resto = (soma * 10) % 11;
        if ((resto === 10) || (resto === 11)) {
            resto = 0;
        }
        if (resto !== parseInt(cpfSemCaracteresEspeciais.substring(9, 10), 10)) {
            return false;
        }
        soma = 0;
        for (let i = 1; i <= 10; i += 1) {
            soma += parseInt(cpfSemCaracteresEspeciais.substring(i - 1, i), 10) * (12 - i);
        }
        resto = (soma * 10) % 11;
        if ((resto === 10) || (resto === 11)) {
            resto = 0;
        }
        if (resto !== parseInt(cpfSemCaracteresEspeciais.substring(10, 11), 10)) {
            return false;
        }
        return true;
    }

    static contarPalavras(resumo) {
        let resumoAlterado = resumo;
        if (!resumo) {
            return 0;
        }
        // Remover caracteres que não são palavras.
        while (resumoAlterado.indexOf('\n') >= 0) {
            resumoAlterado = resumoAlterado.replace('\n', ' ');
        }
        while (resumoAlterado.indexOf('–') >= 0) {
            resumoAlterado = resumoAlterado.replace('–', ' ');
        }
        while (resumoAlterado.indexOf(',') >= 0) {
            resumoAlterado = resumoAlterado.replace(',', ' ');
        }
        while (resumoAlterado.indexOf('.') >= 0) {
            resumoAlterado = resumoAlterado.replace('.', ' ');
        }
        while (resumoAlterado.indexOf('  ') >= 0) {
            resumoAlterado = resumoAlterado.replace('  ', ' ');
        }
        // Contar as palavras.
        const count = resumoAlterado.trim().split(' ').length;
        return count;
    }

    static getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    static getBase64Encode(text) {
        return new Buffer(text).toString('base64');
    }
    static getBase64Decode(text) {
        return Buffer.from(text, 'base64').toString('ascii');
    }
}

export default Utils;
